<template>
  <div>
    <titulo-modulo titulo="Dependentes" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <div class="mt-3" v-else>
      <v-alert v-if="dependentes.length == 0" type="info" text>
        Nenhum dependente encontrado
      </v-alert>
      <v-btn
        max-height="35"
        color="info"
        rounded
        :to="{ name: 'incluir-dependente' }"
        :block="$mq == 'sm'"
        :class="$mq == 'sm' ? 'mb-2' : ''"
      >
        <v-icon size="20" class="mr-2">mdi-plus</v-icon> Incluir
        Dependente</v-btn
      >
      <botao-ajuda />
      <modal-ajuda />

      <v-tabs
        class="mt-3"
        grow
        v-model="tab"
        background-color="green lighten-4"
        active-class="font-weight-bold"
        slider-size="3"
      >
        <v-tab>Dependentes</v-tab>
        <v-tab
          >Pendências
          <v-badge
            color="warning"
            :content="pendenciasDependentes().length"
            v-if="pendenciasDependentes().length > 0"
          ></v-badge>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card>
            <v-card-text>
              <v-row class="mb-5">
                <v-col cols="12">
                  <v-card flat>
                    <v-card-text>
                      <v-expansion-panels flat>
                        <card-dependente
                          v-for="(dependente, i) in dependentes"
                          :key="i"
                          :dependente="dependente"
                        />
                      </v-expansion-panels>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-text>
              <v-row class="mb-5" v-if="pendenciasDependentes().length > 0">
                <v-col cols="12">
                  <v-card flat>
                    <v-card-text>
                      <v-expansion-panels flat>
                        <card-dependente
                          v-for="(dependente, i) in pendenciasDependentes()"
                          :key="i"
                          :dependente="dependente"
                        />
                      </v-expansion-panels>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col>
                  <v-alert type="info" text
                    >Nenhuma pendência encontrada</v-alert
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import TituloModulo from "../../components/TituloModulo.vue";
import CardDependente from "./components/CardDependente.vue";
import { mapActions, mapState } from "vuex";
import BotaoAjuda from "./components/BotaoAjuda.vue";
import ModalAjuda from "./components/ModalAjuda.vue";

export default {
  components: { TituloModulo, CardDependente, BotaoAjuda, ModalAjuda },
  computed: mapState("dependentes", ["dependentes"]),
  data: () => ({
    carregando: false,
    tab: 0,
  }),
  methods: {
    ...mapActions("dependentes", ["getDependentes"]),
    pendenciasDependentes() {
      return this.dependentes.filter((d) => d.status == 2);
    },
  },
  async mounted() {
    this.carregando = true;
    await this.getDependentes("");
    this.carregando = false;
  },
};
</script>
